import type { CommunityNotificationSettings } from 'models';
import { CheckboxInput } from 'ui';
import { isChangeAllowed } from '../utilities';

const NotificationCheckbox = ({
  label,
  notificationEntity,
  notificationSettings,
  notificationType,
}: {
  label: string;
  notificationEntity: 'events' | 'giving' | 'newsfeed' | 'program';
  notificationSettings: CommunityNotificationSettings;
  notificationType: 'emailNotificationsSettings' | 'pushNotificationsSettings';
}) => {
  if (!isChangeAllowed({ notificationEntity, notificationSettings, notificationType })) {
    return null;
  }

  return (
    <CheckboxInput
      item={{
        label,
        name: [notificationType, notificationEntity],
        valuePropName: 'checked',
      }}
    />
  );
};

export default NotificationCheckbox;
